import React, { useState } from "react";
import { Link } from "react-router-dom";

import topics from "resources/primary-topics.json";
import Resource from "components/Resource";
import SelectPhase, { PHASES } from "components/SelectPhase";

export default function PrimaryTopicsPage() {
  const [phase, setPhase] = useState("");

  if (!phase) {
    return (
      <section className="section">
        <h3 className="title is-3">小學教材</h3>
        {SelectPhase(
          PHASES,
          setPhase,
          <Link
            to="/primarypack"
            className="button is-info is-large mx-2"
            role="button"
          >
            教材套
          </Link>
        )}
      </section>
    );
  } else {
    return (
      <Resource
        title={`小學教材 － ${phase}`}
        resource={topics}
        phase={phase}
      />
    );
  }
}
